import { AxiosError } from 'axios'
import { ApiProvider } from '../provider'
import { APIRoutes } from '../routes'
import { GetInvoiceDocResponse, InvoiceListResponse } from 'api/types/invoice'

class Invoice {
  // get all invoices
  async getInvoiceList({
    brokerNo,
    receiptNo,
    policyNo,
    nif,
    product,
    invoicedFrom,
    invoicedTo,
    stage,
    page,
    output,
  }: {
    brokerNo: number
    receiptNo?: string
    policyNo?: string
    nif?: string
    product?: string
    stage?: string
    invoicedFrom?: string
    invoicedTo?: string
    page: number
    output?: 'Excel'
  }): Promise<InvoiceListResponse | (AxiosError | Error)> {
    if (!brokerNo) return Error('BrokerNo is required')
    let url
    if (output) {
      url = `${APIRoutes.invoice.getInvoiceList}?brokerNo=${brokerNo}`
    } else {
      url = `${APIRoutes.invoice.getInvoiceList}?brokerNo=${brokerNo}&skip=${
        page * 50
      }&take=50`
    }

    if (receiptNo) {
      url += `&receiptNo=${receiptNo}`
    }

    if (nif) {
      url += `&nif=${nif}`
    }

    if (invoicedFrom) {
      url += `&invoicedFrom=${invoicedFrom}`
    }

    if (invoicedTo) {
      url += `&invoicedTo=${invoicedTo}`
    }

    if (product) {
      url += `&product=${product}`
    }

    if (policyNo) {
      url += `&policyNo=${policyNo}`
    }

    if (stage) {
      url += `&stage=${stage}`
    }

    if (output) {
      url += `&output=${output}`
    }

    return ApiProvider.getRequest(url) as Promise<
      InvoiceListResponse | (AxiosError | Error)
    >
  }

  // get invoice document (pdf)
  async getInvoiceDoc({
    invoiceNo,
    brokerNo,
  }: {
    invoiceNo: string
    brokerNo: number
  }) {
    return ApiProvider.getRequest(
      `${APIRoutes.invoice.getInvoiceDoc}?brokerNo=${brokerNo}&invoiceNo=${invoiceNo}`,
    ) as Promise<GetInvoiceDocResponse | (AxiosError | Error)>
  }
}

export const invoiceService = new Invoice()
